import script from "./home.vue?vue&type=script&setup=true&lang=js"
export * from "./home.vue?vue&type=script&setup=true&lang=js"

import "./home.vue?vue&type=style&index=0&id=5fc810b4&lang=scss&scoped=true"

import exportComponent from "/Users/kexikui/Desktop/code/dlmk/dlmk-mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fc810b4"]])

export default __exports__